<app-desktop-navigation-bar
  class="d-none d-lg-block"
></app-desktop-navigation-bar>
<app-mobile-navigation-bar
  class="d-block d-lg-none"
></app-mobile-navigation-bar>
